export default "__VITE_ASSET__B34Ii0Lc__"